import { passwordCheck } from '../utils/passwordCheck';
import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['label', 'meter', 'passwordInput', 'strength', 'wrapper'];

  declare labelTarget: HTMLElement;
  declare meterTarget: HTMLElement;
  declare passwordInputTarget: HTMLInputElement;
  declare strengthTarget: HTMLElement;
  declare wrapperTarget: HTMLElement;

  /**
   * Read & Report Password Strength.
   *
   * Utilize check-password-strength library to report strength of password
   * to the DOM. i.e. weak, Medium, or Strong.
   */
  report() {
    const input = this.passwordInputTarget.value;
    const { label, value } = this.strengthMetrics(input);

    // show & hide password strength
    this.wrapperTarget.hidden = !(input.length > 0);

    // show password strength label
    this.labelTarget.innerText = label;
    ['weak', 'medium', 'strong'].forEach((klass) => {
      this.strengthTarget.classList.remove(klass);
    });
    this.strengthTarget.classList.add(value);

    // activate meter bar
    this.animatePasswordMeter(value);
  }

  private animatePasswordMeter(value) {
    const [bar1, bar2, bar3] = this.meterTarget.children;

    switch (value) {
      case 'medium':
        this.activate(bar1);
        this.activate(bar2);
        this.deactivate(bar3);
        break;
      case 'strong':
        this.activate(bar1);
        this.activate(bar2);
        this.activate(bar3);
        break;
      default:
        this.activate(bar1);
        this.deactivate(bar2);
        this.deactivate(bar3);
    }
  }

  private strengthMetrics(input) {
    const strength = passwordCheck(input);
    const translations = window.site.translations.elc_general;
    const metrics = { label: '', value: strength };

    switch (strength) {
      case 'medium':
        metrics.label = translations.medium;
        break;
      case 'strong':
        metrics.label = translations.strong;
        break;
      default:
        metrics.label = translations.weak;
    }

    return metrics;
  }

  private activate(el) {
    el.classList.add('active');
  }
  private deactivate(el) {
    el.classList.remove('active');
  }
}
